import React from "react";
import ReactDOM from "react-dom";
import registerServiceWorker from "./registerServiceWorker";

// TODO: bootstrap and main css, js's template
import "./assets/base";

import { Main } from "./modules/Setup/MainRoute";

ReactDOM.render(<Main />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js